import React from 'react';
import styled from '@emotion/styled';

import AnimatedLoader from 'shared/components/BelowTheFoldControl/AnimatedLoader';


interface Props {
  length: number;
}

const CardWrapper = styled.div`
  flex: 1 50%;
  border-bottom: 2px solid #e1e1e1;
  border-right: 2px solid #e1e1e1;
  max-width: 50%;
  padding-bottom: 32px;
`;

const Image = styled(AnimatedLoader)`
  width: 100%;
  height: 100px;
  display: inline-block;
  margin-bottom: 10px;
`;

const DetailsWrapper = styled.div`
  padding-left: 15px;
  padding-right: 15px;
`;

const Line = styled(AnimatedLoader)`
  height: 7px;
  margin-bottom: 10px;
  width: 100%;
`;

const ListWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  background-color: #fff;
`;

const getView = (count: number) => {
  const loader = [];
  for (let i = 0; i < count; i += 1) {
    loader.push(
      <CardWrapper key={`listing_loder_${i}`}>
        <Image className="client"/>
        <DetailsWrapper>
          <Line className="client"/>
          <Line className="client"/>
          <Line className="client"/>
          <Line className="client"/>
          <Line className="client"/>
        </DetailsWrapper>
      </CardWrapper>
    );
  }
  return loader;
};


export const ListingProductLoader = ({ length }: Props) => (
  <ListWrapper>
    {getView(length)}
  </ListWrapper>
);
